import { Box } from '@mui/system';
import React, { useState } from 'react';
import perfectBadge from '../../../assets/images/perfect-badge.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const BP1 = '@media (max-width: 450px)';

const sx = {
  root: {
    width: '100%',
    margin: 'auto',
  },
  imageContainer: {
    position: 'relative',
    maxWidth: 'auto',
    minHeight: '450px',
    margin: 'auto',
    [BP1]: {
      minHeight: '300px',
      mb: '50px',
    },
  },
  image: {
    width: '100%',
    height: '100%',
    border: '5px solid #FF692B',
    borderRadius: '28px',
  },
  traitContainer: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    top: '10px',
    right: '10px',
  },
  traitHolder: {
    width: '35px',
    height: '35px',
    borderRadius: '8px',
    backgroundColor: 'black',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#FF692B',
    },
    '& img': {
      width: '25px ',
      height: '15px ',
      transition: '0',
      objectFit: 'contain !important',
      borderRadius: '0px !important',
      position: 'inherit !important',
    },
    [BP1]: {
      width: '35px',
      height: '35px',
      '& img': {
        width: '25px !important',
        height: '20px !important',
        transition: '0',
        objectFit: 'contain !important',
        borderRadius: '0px !important',
        position: 'inherit !important',
      },
    },
  },
  medalText: {
    color: '#FFF',
    fontFamily: 'boucherie-block',
    fontSize: '20px',
  },
};

const RanksCard = ({
  img,
  showPerfectBadge,
  allowFullScreen,
  scopeId,
  scopeStyle,
}) => {
  const [traitsVisible, setTraitsVisible] = useState(false);
  // const [selectedTrait, setSelectedTrait] = useState(TRAITS[0])

  const showTraits = () => {
    setTraitsVisible(true);
    document.getElementById(`${scopeId}`).style.transform =
      'perspective(1000px) rotateY(180deg)';
    // document.getElementById("scope").style.transition = "all .35s ease-in-out";
  };
  const hideTraits = () => {
    setTraitsVisible(false);
    document.getElementById(`${scopeId}`).style.transform =
      'perspective(1000px) rotateY(0deg)';
  };

  return (
    <Box>
      <Box sx={sx.imageContainer}>
        <div className="pyramid_anim_container">
          <div
            className={`scope ${traitsVisible ? 'active' : ''}  `}
            id={scopeId}
            style={scopeStyle}
          >
            <span className={`front ${!traitsVisible ? 'active' : ''} `}>
              <img
                className="flipped-img"
                src={img}
                alt="not found"
                style={{ borderRadius: '20px' }}
              />
              {showPerfectBadge && (
                <LazyLoadImage
                  className="badge-img"
                  src={perfectBadge}
                  alt="not found"
                  // onClick={() => {
                  //     showTraits()
                  //     setSelectedTrait(TRAITS[6])
                  // }}
                />
              )}
            </span>
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default RanksCard;
